import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { AppBar, Toolbar, Typography, Tooltip, Avatar } from '@mui/material';
//import { Link } from 'react-router-dom';
import DivIcon from '@mui/icons-material/Diversity1';
//import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
//import { green, red, grey, white, yellow } from '@mui/material/colors';
import { BASE_URL } from '../api/index';
import CopyrightIcon from '@mui/icons-material/Copyright';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
            <NavMenu />
            <AppBar position="static">
                <Container sx={{ width: '100%', display: 'flex' }}>
                    <Toolbar disableGutters>
                        <Tooltip title="You are the reason why we are here!">
                            <DivIcon sx={{ display: { xs: 1, md: 'flex' }, ml: 1 }} />
                        </Tooltip>
                        <Typography
                            variant="h5"
                            align="center"
                            noWrap
                            sx={{
                                flexGrow: 1,
                                fontFamily: 'arial',
                                fontSize: '1rem',
                                fontWeight: 700,
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            MVP CARE SERVICES, LLC
                        </Typography>
                        <Avatar alt="Habib" src={BASE_URL + 'Images/habib.PNG'} sx={{ width: 56, height: 56, ml: 1 }} />
                    </Toolbar>
                </Container>
            </AppBar>
            {/*</NavbarBrand>*/}
            {/*</Navbar>*/}
            <Container>
                {this.props.children}
            </Container>
            <AppBar position="static">
                <Container sx={{ width: '100%', display: 'flex' }}>
                    <Toolbar disableGutters>
                        <Typography
                            sx={{
                                fontFamily: 'arial',
                                fontSize: '0.65rem',
                                fontWeight: 50,
                                color: 'inherit',
                            }}
                        >
                            <CopyrightIcon sx={{ display: 'flex', height: '17px', width: 'auto' }} />awg/ISID
                        </Typography>
                        <Typography
                            variant="h5"
                            align="center"
                            noWrap
                            component="a"
                            href="tel:1-317-856-426-5845"
                            sx={{
                                flexGrow: 1,
                                fontFamily: 'arial',
                                fontSize: '1rem',
                                fontWeight: 700,
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            (856) 426-5845
                        </Typography>
                        {/*<Tooltip>*/}
                        {/*    <EmailIcon sx={{ display: { xs: 1, md: 'flex' }, ml: 1 }} />*/}
                        {/*</Tooltip>*/}
                        <Typography
                            component="a"
                            href="mailto:mvpcareservices10618@gmail.com"
                            sx={{
                                fontSize: '0.8rem', fontWeight: 700,
                                color: 'inherit',
                                textDecoration: 'none',
                            }}>
                            <EmailIcon sx={{ display: { xs: 1, md: 'flex' }, ml: 1 }} />
                        </Typography>
                        {/*<Avatar alt="Habib" src={BASE_URL + 'Images/habib.PNG'} sx={{ width: 56, height: 56, ml: 1 }} />*/}
                    </Toolbar>
                </Container>
            </AppBar>
        {/*<Container>*/}
        {/*  {this.props.children}*/}
        {/*</Container>*/}
      </div>
    );
  }
}
